/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { GetMaintenanceRecordResponse } from './GetMaintenanceRecordResponse';
export type MaintenanceNotificationWithRecordResponse = {
  id: number;
  puid: string;
  vin: string;
  sestCode: string;
  newRecord: GetMaintenanceRecordResponse;
  existRecord: GetMaintenanceRecordResponse;
  type: MaintenanceNotificationWithRecordResponse.type;
  decisionType: MaintenanceNotificationWithRecordResponse.decisionType;
  status: MaintenanceNotificationWithRecordResponse.status;
  actionTaken: MaintenanceNotificationWithRecordResponse.actionTaken;
  dataSource: MaintenanceNotificationWithRecordResponse.dataSource;
  createdAt: string;
  updatedAt: string;
};
export namespace MaintenanceNotificationWithRecordResponse {
  export enum type {
    NEW_RECORD = 'NEW_RECORD',
    KEEP_RECORD = 'KEEP_RECORD',
    COMPARISON = 'COMPARISON',
  }
  export enum decisionType {
    MANUAL = 'MANUAL',
    AUTOMATIC = 'AUTOMATIC',
  }
  export enum status {
    UNREAD = 'UNREAD',
    READ = 'READ',
    PROCESSED = 'PROCESSED',
  }
  export enum actionTaken {
    KEEP_BOTH = 'KEEP_BOTH',
    KEEP_NEW_RECORD = 'KEEP_NEW_RECORD',
    KEEP_EXIST_RECORD = 'KEEP_EXIST_RECORD',
    PENDING_DECISION = 'PENDING_DECISION',
    RECORD_ADDED = 'RECORD_ADDED',
  }
  export enum dataSource {
    SERVICE_CENTER = 'SERVICE_CENTER',
    USER = 'USER',
    ADMIN = 'ADMIN',
  }
}

